import { flyoutNavShape } from "../PrimaryNav/primaryNavTypes.js";
import useDetectUserAgent from "../../../common/useDetectUserAgent.js";
import MegaMenuDropdown from "./MegaMenuDropdown.jsx";
import MenuItem from "../PrimaryNav/MenuItem.jsx";

const propTypes = {
  navItems: flyoutNavShape,
};

const MegaMenu = (props) => {
  const { navItems } = props;

  const windowsPlatformClassname = useDetectUserAgent();

  return (
    <nav className="mega-menu primary-nav" aria-label="Primary Navigation">
      <ul className={`mega-menu__items ${windowsPlatformClassname}`}>
        {navItems.map((item, i) => {
          if (item.children && item.children.length > 0) {
            return <MegaMenuDropdown item={item} key={i} />;
          } else {
            return (
              <li key={i} className="mega-menu__item">
                {/* <MenuItem className="primary-nav__item" item={item} /> */}
                <a
                  className="primary-nav__item"
                  href={item.href}
                  target={item.target}
                >
                  {item.title}
                </a>
              </li>
            );
          }
        })}
      </ul>
    </nav>
  );
};

MegaMenu.propTypes = propTypes;
export default MegaMenu;
